import { breakpoints } from '../utils/breakpoints';

const handleContactMap = async () => {
  const selectors = {
    mapContainer: '.js-leaflet-map',
  };

  const mapContainers = document.querySelectorAll(selectors.mapContainer);

  if (mapContainers.length === 0) return;

  // Import library dynamically
  const { default: L } = await import('leaflet');
  await import('leaflet/dist/leaflet.css');

  mapContainers.forEach((mapContainer) => {
    const { mapLat, mapLng, mapLink } = mapContainer.dataset;

    const mapCenterCoordinates = [mapLat, mapLng];

    // Create map
    const map = L.map(mapContainer, {
      center: mapCenterCoordinates,
      scrollWheelZoom: false,
      zoom: 13,
      attributionControl: false,
    });

    // Load map tile layer
    const CartoDB_Positron = L.tileLayer(
      'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
      {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd',
        maxZoom: 20,
      }
    );

    // Set icon dimensions depending on client screen size
    const iconDims = {
      width: window.innerWidth < breakpoints.tablet ? 18 : 33,
      height: window.innerWidth < breakpoints.tablet ? 20 : 40,
    };

    // Add icon HTML
    const iconHTML = `
   <svg width="33" height="40" viewBox="0 0 33 40" fill="none" xmlns="http://www.w3.org/2000/svg">
   <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5625 16.7744C0.5625 7.95799 7.76978 0.832031 16.4877 0.832031C25.2302 0.832031 32.4375 7.95799 32.4375 16.7744C32.4375 21.2171 30.8569 25.3417 28.2553 28.8376C25.3853 32.6938 21.8478 36.0536 17.866 38.6908C16.9547 39.3003 16.1323 39.3463 15.1321 38.6908C11.1276 36.0536 7.59016 32.6938 4.74469 28.8376C2.14122 25.3417 0.5625 21.2171 0.5625 16.7744ZM11.2392 17.2708C11.2392 20.2243 13.5969 22.5472 16.4877 22.5472C19.3805 22.5472 21.7608 20.2243 21.7608 17.2708C21.7608 14.3403 19.3805 11.9043 16.4877 11.9043C13.5969 11.9043 11.2392 14.3403 11.2392 17.2708Z" fill="#E86931"/>
   </svg>
   `;

    // Create SVG icon
    const svgIcon = L.divIcon({
      html: iconHTML,
      className: 'leaflet-custom-marker',
      iconSize: [iconDims.width, iconDims.height],
      iconAnchor: [iconDims.width * 0.5, iconDims.height],
    });

    // Create marker
    const marker = L.marker(mapCenterCoordinates, {
      className: 'leaflet-custom-marker',
      icon: svgIcon,
    });

    // Add layer to map
    CartoDB_Positron.addTo(map);

    // Add marker to map
    marker.addTo(map);

    if (mapLink === '') return;

    // Add click event to open link
    marker.on('click', () => {
      window.open(mapLink);
    });
  });
};

export default handleContactMap;
